import { render, staticRenderFns } from "./circleItem.vue?vue&type=template&id=3a8680ec&scoped=true"
import script from "./circleItem.vue?vue&type=script&lang=js"
export * from "./circleItem.vue?vue&type=script&lang=js"
import style0 from "./circleItem.vue?vue&type=style&index=0&id=3a8680ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8680ec",
  null
  
)

export default component.exports